// DaysOfWeekCircles.js
import React from "react";
import "./Components.css"; // optional if you have CSS
import pt from "../i18n/pt.json";
import en from "../i18n/en.json";
import de from "../i18n/de.json";
import { useLanguage } from "../context/LanguageContext";

export default function DaysOfWeekCircles({ daysArray = [] }) {
  const { t } = useLanguage();
  const LABELS = t("weekday_initials");

  return (
    <div className="days-of-week-container">
      {daysArray.map((val, idx) => {
        const isActive = val === 1;
        return (
          <div
            key={idx}
            className={`day-circle ${isActive ? "active" : ""}`}
            title={LABELS[idx]}
          >
            {LABELS[idx]}
          </div>
        );
      })}
    </div>
  );
}
